import { render, staticRenderFns } from "./ReportRemoveModal.vue?vue&type=template&id=6c15b3f4&lang=html&"
import script from "./ReportRemoveModal.vue?vue&type=script&lang=js&"
export * from "./ReportRemoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports